const HOUR_HEIGHT = 60;

export const toMinutesFromStr = (timeStr) => {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
}

export const isFuture = (date) => {
    const today = new Date();
    const d1 = new Date(date);
    const d2 = new Date(today);
    //  YYYY-MM-DD
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    return d1 > d2;
}

export const isPast = (date) => {
    const today = new Date();
    const d1 = new Date(date);
    const d2 = new Date(today);
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    return d1 < d2;
}

export const getWeekDates = (startDate = new Date()) => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
        const d = new Date(startDate);
        d.setDate(d.getDate() + i);
        dates.push({
            date: d,
            day: d.toLocaleDateString("en-US", { weekday: "short" }),
            label: d.getDate(),
            iso: d.toISOString().split("T")[0]
        });
    }
    return dates;
}

export const getSlotDuration = (slot) => {
    const start = new Date(slot.startDateTime);
    const end = new Date(slot.endDateTime);
    return (end - start) / (1000 * 60);
}

export const getSlotHeight = (slot) => {
    const duration = getSlotDuration(slot);
    return (duration / 60) * HOUR_HEIGHT;
}

export const getMinutes = (dateStr) => {
    const fixed = dateStr.replace("Z", "");
    const d = new Date(fixed);
    return d.getHours() * 60 + d.getMinutes();
}

export const getSlotForTime = (daySlots, time) => {
    const timeMin = toMinutesFromStr(time.startTime);
    return daySlots.find(slot => {
        const start = getMinutes(slot.startDateTime);
        const end = getMinutes(slot.endDateTime);

        return timeMin >= start && timeMin < end;
    });
}

export const formatUTC = (date) => {
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    const formattedMinutes = minutes.toString().padStart(2, "0");

    return `${hours}:${formattedMinutes} ${ampm}`;
}

export const groupEventsByType = (events) => {
    const grouped = {};

    events.forEach((ev) => {
        if (!grouped[ev.eventType]) {
            grouped[ev.eventType] = [];
        }
        grouped[ev.eventType].push(ev);
    });

    return Object.values(grouped);
}